import React from 'react';
import divider from '../../assets/divider-img.png';
import i1 from '../../assets/metric/i1.png';
import i2 from '../../assets/metric/i2.png';
import i3 from '../../assets/metric/i3.png';

const BacktestPerformanceMet = () => {
  return (
    <div className="backtest-component performance-met-div">
      <div className="container">
        <div className="backtest-main-wrapper comprehensive-main-wrapper">
          <div className="backtest-heading-description tab-head-center">
            <h2>Comprehensive Performance Metrics</h2>
            <div className="divider">
              <img src={divider} alt="divider" />
            </div>
            <p>
              We provide a detailed analysis of backtesting results, covering
              metrics like Sharpe ratio, drawdown, and annualized returns. This
              helps traders make informed decisions about their strategies.
            </p>
          </div>
          <div className="backtest-content">
            <div className="performance-met-items">
              <div className="performance-met-item graph1">
                <img src={i1} alt="met-item" />
              </div>
              <div className="performance-met-item graph2 tab-mlr">
                <img src={i2} alt="met-item" />
              </div>
              <div className="performance-met-item graph3">
                <img src={i3} alt="met-item" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BacktestPerformanceMet;
